export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/about": [5,[2]],
		"/about/community": [7,[2]],
		"/about/[page]": [6,[2]],
		"/contact": [8],
		"/donate": [9],
		"/remux": [10],
		"/settings": [11,[3]],
		"/settings/accessibility": [12,[3]],
		"/settings/advanced": [13,[3]],
		"/settings/appearance": [14,[3]],
		"/settings/audio": [15,[3]],
		"/settings/debug": [16,[3]],
		"/settings/instances": [17,[3]],
		"/settings/local": [18,[3]],
		"/settings/metadata": [19,[3]],
		"/settings/privacy": [20,[3]],
		"/settings/video": [21,[3]],
		"/updates": [22]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';